import type { UserSettings } from "@/domain/entities";
import { useApp } from "../container";
import { useQuery, type QueryState } from "./useQuery";

export function useSettings(): QueryState<UserSettings> {
  const app = useApp();
  return useQuery(() => app.store.settings.get(), [], app.changeSources);
}
